import { render, staticRenderFns } from "./SingleStudentRoadmap.vue?vue&type=template&id=328aa15e&scoped=true"
import script from "./SingleStudentRoadmap.vue?vue&type=script&lang=js"
export * from "./SingleStudentRoadmap.vue?vue&type=script&lang=js"
import style0 from "./SingleStudentRoadmap.vue?vue&type=style&index=0&id=328aa15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328aa15e",
  null
  
)

export default component.exports